module.exports = __webpack_public_path__ + "static/volgai_logo-bfae1a6fea60831548af5147a7d3da5f.jpg";